export default __webpack_public_path__ + "static/wand-education_caver_small-a18e3e97b0aa720c398b737cb4860573.webp";